import * as services from '@/services'
import sectionsSummary from '@/data/sections-summary'

export default {
  namespaced: true,

  state: {
    topics: {
      selected: null,
      isLoading: false
    }
  },

  getters: {
    defineIsPremiumTopicBySlug: () => topicSlug => {
      const topics = sectionsSummary.sections.flatMap(section => section.topics)

      return topics.some(
        topic =>
          topic.slug === topicSlug &&
          ['intermediate', 'advanced'].includes(topic.level)
      )
    },

    defineIsLockedForDemo: () => topicSlug => {
      const allowed = [
        'articles',
        'countable-uncountable',
        'do-does'
        // 'have-has',
      ]

      return !allowed.includes(topicSlug)
    }
  },

  actions: {
    async FETCH_ONE_BY_SLUG(
      { commit },
      { topicSlug, isOnlyHighQuality = false, limit = 10 }
    ) {
      await Promise.all([
        commit('SET_SELECTED', null),
        commit('SET_IS_LOADING', true)
      ])

      let { content } = await services.topics.getOneBySlug({
        slug: topicSlug,
        isOnlyHighQuality,
        limit
      })

      const topic = { ...content, exercises: [] }
      const exerciseList = content.exercises

      await Promise.all([
        commit('SET_IS_LOADING', false),
        commit('SET_SELECTED', topic),
        commit('exercises/SET_LIST', exerciseList, { root: true })
      ])
    }
  },

  mutations: {
    SET_SELECTED(state, selected) {
      state.topics.selected = selected
    },
    SET_IS_LOADING(state, isLoading) {
      state.topics.isLoading = isLoading
    }
  }
}
